import { Component } from 'react';
import API from '../shared/forms/API';

export default class UserName extends Component {
  state = {
    name: '...'
  };

  componentDidMount() {
    new API()
      .fetch('users/' + this.props.uuid)
      .then((data) => data.json())
      .then((user) => {
        this.setState({ name: user.display_name });
      })
      .catch((error) => this.setState({ name: '(niet beschikbaar)' }));
  }

  render() {
    return this.state.name;
  }
}
